"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Tabs.css");
function Item(_a) {
    var children = _a.children;
    return React.createElement(React.Fragment, null, children);
}
function Tabs(_a) {
    var children = _a.children, _b = _a.activeTab, activeTab = _b === void 0 ? 0 : _b, onChange = _a.onChange;
    var renderTabs = React.Children.map(children, function (child, index) {
        var handleOnclickTab = function () { return onChange(index); };
        var label = child.props.label;
        var tabClassName = (0, classnames_1.default)("nimbus--tab", {
            "nimbus--tab--active": activeTab === index,
        });
        return (React.createElement("li", { key: label, role: "tab", className: tabClassName, onClick: handleOnclickTab }, label));
    });
    var renderActiveChild = (React.createElement(React.Fragment, null,
        " ",
        React.Children.toArray(children)[activeTab],
        " "));
    return (React.createElement("div", { className: "nimbus--tabs-wrapper" },
        React.createElement("ul", { role: "tablist", className: "nimbus--tabs" }, renderTabs),
        React.createElement("div", { role: "tabpanel", className: "nimbus--tabs-content" }, renderActiveChild)));
}
Tabs.Item = Item;
exports.default = Tabs;
//# sourceMappingURL=index.js.map